function ErrorHandler (props: any): JSX.Element {
  return (
    <div role="alert">
      <p>An error occurred:</p>
      <pre>{props.error.message}</pre>
    </div>
  )
}

export default ErrorHandler
